export const UPDATE_PERMISSIONS = content => ({
    type: "UPDATE_PERMISSIONS",
    payload: content
});